import {CalculationSettingsModel} from "../configuration";
import {GritFeature} from "./grit.feature";
import {DeviceModel, InterferenceTestDeviceModel} from "./grit.device-model";
import {Sectorization} from "../sectorization";
import {GritUtils} from "../../utils/grit/GritUtils";
import {InterferenceTestModel} from "./grit.interference-test-model";
import {ReceiverModel} from "./grit.receiver-model";
import * as olExtent from "ol/extent";
import {toLonLat} from "ol/proj";

export class DeviceCalculationDTO{
  id: string;
  name: string;
  type: string;
  longitude: number;
  latitude: number;
  maskLatitude: number;
  maskLongitude: number;
  frequency: number; //HZ
  range: number;
  effectiveHeight: number;
  devicePower: number; //dBW
  deviceGain: number; //dBi
  receiverPower: number; //dBW
  receiverGain: number; //dBi
  sectorizations: Sectorization[];
  antennaPolarisation: string;
  polarisationLoss: number; // dB

  static fromFeature(features: GritFeature<InterferenceTestDeviceModel>[], receiver : ReceiverModel) : DeviceCalculationDTO[]{
    return features.map(feature => {
      let itDevice = feature.entity;
      let deviceCalculation = new DeviceCalculationDTO();

      deviceCalculation.id = `${itDevice.id}-${receiver.id}-${receiver.deviceType.charAt(0).toUpperCase()}` //Type needed for display;
      deviceCalculation.name = `${itDevice.name}-${receiver.name}`;
      deviceCalculation.type = `${itDevice.device.type}-${receiver.deviceType}`;
      deviceCalculation.latitude = itDevice.latitude.value;
      deviceCalculation.longitude = itDevice.longitude.value;

      if (itDevice.maskGeometry != null){

        let coord = olExtent.getCenter(itDevice.maskGeometry.getExtent())
        coord = toLonLat(coord,"EPSG:3857");

        deviceCalculation.maskLatitude = coord[1];
        deviceCalculation.maskLongitude = coord[0];
      }

      deviceCalculation.frequency = itDevice.device.frequencyHz;
      deviceCalculation.devicePower = itDevice.device.power.dBW;
      deviceCalculation.deviceGain = itDevice.device.verticalGain;
      deviceCalculation.receiverPower = receiver.threshold.dBW;
      deviceCalculation.receiverGain = receiver.gain;
      
      deviceCalculation.antennaPolarisation = itDevice.device.antennaPolarisation;
      deviceCalculation.polarisationLoss = itDevice.device.polarisationLoss;

      deviceCalculation.range = GritUtils.fsplDistance(deviceCalculation.frequency,
        deviceCalculation.devicePower, deviceCalculation.deviceGain, deviceCalculation.polarisationLoss,
        deviceCalculation.receiverPower, deviceCalculation.receiverGain);

      deviceCalculation.effectiveHeight = 0;
      deviceCalculation.sectorizations = itDevice.device.sectorizations.flatMap(sect => {
        let doc = GritUtils.fsplDistance(
          itDevice.device.frequencyHz, sect.power.dBW, sect.gain + itDevice.device.verticalGain, itDevice.device.polarisationLoss,
          receiver.threshold.dBW, receiver.gain);
        return sect.toSectorization(doc, 0, 60000, itDevice.direction)
      });

      return deviceCalculation;
    })
  }
}

export class ImpactAssessmentDTO {
  name: string;
  minAltitude: number;
  maxAltitude: number;
  altitudeInterval: number;
  calculationSettings: CalculationSettingsModel;
  projectId: number;

  devices: DeviceCalculationDTO[] = [];

  constructor(name: string, minAltitude: number,  maxAltitude: number,
              altitudeInterval: number, settings: CalculationSettingsModel, projectId: number){
    this.name = name;
    this.minAltitude = minAltitude;
    this.maxAltitude = maxAltitude;
    this.altitudeInterval = altitudeInterval;
    this.calculationSettings = settings;
    this.projectId = projectId;
  }

  addDevices(features: GritFeature<InterferenceTestDeviceModel>[], receiver : ReceiverModel){
    this.devices.push(...DeviceCalculationDTO.fromFeature(features, receiver));
  }
}
